import { useEffect, useRef } from "react";
import { useSocket } from "./useSocket";
import { WebSocketEventsMap } from "../services/socket/events-map";

export function useAutomaticAssignmentSocket({ onOrderAssigned } = {}) {
  const { connect, disconnect, on } = useSocket();
  const callbackRef = useRef(onOrderAssigned);
  callbackRef.current = onOrderAssigned;

  useEffect(() => {
    connect();

    const unsub = on(WebSocketEventsMap.Assignment.ORDER_ASSIGNED, (data) => {
      callbackRef.current?.(data);
    });

    return () => {
      unsub();
      disconnect();
    };
  }, [connect, disconnect, on]);
}
